import { TBusinessAppoinment } from '../services/businessPossibleAppointments/getBusinessPossibleAppointments/types';

export enum EBusinessType {
  /** Арендный бизнес */
  RentalBusiness = 'rentalBusiness',
  /** Готовый бизнес */
  ReadyBusiness = 'readyBusiness',
  /** Другое */
  Other = 'other',
}

export type TBusinessAppointmentsState = {
  isLoaded: boolean;
  data: TBusinessAppoinment['businessAppointments'];
};
